export default __webpack_public_path__ + "static/media/teddy2.3abefe7b.jpg";